import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GamesRequestParams } from '../types/GamesRequestParams';

export type ParamsStateType = {
  params: GamesRequestParams;
};

export const ParamsInitialState: ParamsStateType = {
  params: {},
};

const slice = createSlice({
  name: 'Params',
  initialState: ParamsInitialState,
  reducers: {
    setParams: (state, action: PayloadAction<GamesRequestParams>) => {
      const params = { ...state.params, ...action.payload };
      // Any filter change (anything other than page itself) resets paging to the
      // first page so we don't land on an out-of-range page after re-filtering.
      if (!('page' in action.payload)) {
        params.page = 0;
      }
      state.params = params;
    },
  },
});
export const { setParams } = slice.actions;
export default slice.reducer;
